import { Component, Inject, OnDestroy } from '@angular/core';
import { assetsConst } from 'src/app/core/const/assets.const';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SpinnerService } from 'src/app/core/services/spinner.service';
import { GeoFenceService } from 'src/app/core/services/geo-fence.service';
import { Subject, takeUntil } from 'rxjs';
import { driverData, driverListResponse } from 'src/app/models/driverData';

@Component({
  selector: 'megastore-admin-assign-drivers',
  templateUrl: './assign-drivers.component.html',
  styleUrls: ['./assign-drivers.component.scss']
})
export class AssignDriversComponent implements OnDestroy {
  displayedColumns = ['position', 'driverimage', 'driverdetail', 'type'];
  assetsConst = assetsConst;
  destroy$: Subject<boolean> = new Subject<boolean>();
  dataSource: Array<driverData> = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { id: string },
    private _spinnerService: SpinnerService,
    private _geoFenceService: GeoFenceService
  ) {
    this.getDrivers();
  }
  getDrivers(): void {
    this._spinnerService.addToLoader('getDriversByGeofence');
    this._geoFenceService
      .getDriverByZone(this.data.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: driverListResponse) => {
          this._spinnerService.removeFromLoader('getDriversByGeofence');
          this.dataSource = res.Drivers;
        },
        error: () => {
          this._spinnerService.removeFromLoader('getDriversByGeofence');
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.complete();
    this.destroy$.unsubscribe();
  }
}
